import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Tooltip } from '@mui/material';
import { GridActionsCellItem, GridColDef } from '@mui/x-data-grid-pro';
import { HandlersUserDetailResponse } from '../../../../../app/athenaApiGen';

// Helper to get roles as string for display
export const getRolesString = (user: HandlersUserDetailResponse): string => {
  if (!user) return '';
  const names = new Set<string>();
  const pushName = (val: unknown) => {
    if (!val) return;
    const trimmed = String(val).trim();
    if (trimmed) names.add(trimmed);
  };

  const roles = user.roles || [];
  for (const r of roles) {
    pushName(r.roleName);
  }

  return Array.from(names).join(', ');
};

export const getUserTableColumns = (
  onDeleteUser: (user: HandlersUserDetailResponse) => void
): GridColDef<HandlersUserDetailResponse>[] => [
  {
    field: 'userName',
    headerName: 'Name',
    flex: 1,
    minWidth: 150,
    valueGetter: (_value, row) => row.userName || row.contact?.name || '-',
  },
  {
    field: 'userEmail',
    headerName: 'Email',
    flex: 1,
    minWidth: 200,
    valueGetter: (value) => value || '-',
  },
  // Roles column hidden from the main view. Restore the block below to
  // re-enable.
  // {
  //   field: 'roles',
  //   headerName: 'Roles',
  //   flex: 1,
  //   minWidth: 200,
  //   valueGetter: (_value, row) => getRolesString(row),
  // },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Remove',
    width: 100,
    cellClassName: 'actions',
    getActions: ({ row }) => [
      <GridActionsCellItem
        key="delete"
        icon={
          <Tooltip
            title="Remove User - This will revoke all permissions including View Financial Dashboard, Create/Edit/Approve Deliverables, and Project access"
            placement="top"
          >
            <DeleteOutlineIcon />
          </Tooltip>
        }
        label="Delete"
        onClick={() => onDeleteUser(row)}
        color="inherit"
      />,
    ],
  },
];
